<!-- Document-only view -->
<div *ngIf="documentOnly" class="document-only-view">
  <div class="a4-document" *ngIf="!isLoading">
    <h2>{{ termsData?.documentName || 'Document Preview' }}</h2>
    <ng-container *ngIf="termsData?.documentUrl">
      <ng-container *ngIf="isSupportedDocument()">
        <!-- PDF Preview: Direct iframe, like admin panel, with toolbar hidden by negative margin -->
        <iframe [src]="sanitizedPdfUrl" width="100%" height="850px" style="border:1px solid #ccc; margin-top: -44px;"></iframe>
      </ng-container>
      <ng-container *ngIf="isOfficeDocument()">
        <iframe [src]="safeOfficeDocumentUrl" width="100%" height="800px" style="border:1px solid #ccc; margin-left: 20%; margin-top: 5%;"></iframe>
      </ng-container>
      <ng-container *ngIf="isImageDocument()">
        <img [src]="termsData.documentUrl" alt="Document Preview" style="max-width: 100%; max-height: 800px; border:1px solid #ccc; display: block; margin: 0 auto;" />
      </ng-container>
      <ng-container *ngIf="isTxtDocument()">
        <iframe [src]="sanitizedPdfUrl" width="60%" height="800px" style="border:1px solid #ccc; margin-left: 20%; margin-top: 5%;"></iframe>
      </ng-container>
      <ng-container *ngIf="isOtherDocument()">
        <a [href]="termsData.documentUrl" target="_blank">Download Document</a>
        <div class="alert alert-warning mt-2">This document type cannot be previewed. Please download to view.</div>
      </ng-container>
    </ng-container>
    <div *ngIf="!termsData?.documentUrl && termsData?.description" [innerHTML]="termsData?.description || 'No content available' | safeHtml"></div>
  </div>
  <div class="loading-container" *ngIf="isLoading">
    <div class="spinner-border text-primary" role="status">
      <span class="sr-only">Loading...</span>
    </div>
    <p class="mt-2">Loading content...</p>
  </div>
</div>

<!-- Regular view with container -->
<div *ngIf="!documentOnly" class="container wrapper-content">
  <h1 class="tc">{{termsData?.title || 'Terms and Conditions'}}</h1>
  <div class="loading-container" *ngIf="isLoading">
    <div class="spinner-border text-primary" role="status">
      <span class="sr-only">Loading...</span>
    </div>
    <p class="mt-2">Loading content...</p>
  </div>
  <div class="document-content" *ngIf="termsData?.documentUrl && !isLoading">
    <div class="document-viewer">
      <ng-container *ngIf="isSupportedDocument()">
        <iframe [src]="sanitizedPdfUrl" width="100%" height="850px" style="border:1px solid #ccc; margin-top: -44px;"></iframe>
      </ng-container>
      <ng-container *ngIf="isOfficeDocument()">
        <iframe [src]="safeOfficeDocumentUrl" width="100%" height="800px" style="border:1px solid #ccc;  margin-top: 2%;"></iframe>
      </ng-container>
      <ng-container *ngIf="isImageDocument()">
        <img [src]="termsData.documentUrl" alt="Document Preview" style="max-width: 100%; max-height: 800px; border:1px solid #ccc; display: block; margin: 0 auto;" />
      </ng-container>
      <ng-container *ngIf="isTxtDocument()">
        <iframe [src]="sanitizedPdfUrl" width="100%" height="800px" style="border:1px solid #ccc;  margin-top: 2%;"></iframe>
      </ng-container>
      <ng-container *ngIf="isOtherDocument()">
        <a [href]="termsData.documentUrl" target="_blank" class="btn btn-primary mb-3">Download Document</a>
        <div class="alert alert-warning">This document type cannot be previewed. Please download it to view.</div>
      </ng-container>
    </div>
  </div>
  <div class="document-content" *ngIf="!termsData?.documentUrl && termsData?.description && !isLoading">
    <div class="document-text" [innerHTML]="termsData?.description | safeHtml"></div>
  </div>
  <div class="no-content" *ngIf="!termsData?.description && !termsData?.documentUrl && !isLoading">
    <p>No content available</p>
  </div>
</div>

<style>
  .document-viewer {
    overflow: hidden;
  }
  iframe {
    scrolling: no;
  }
  .a4-document {
    min-height: 800px;
    height: auto;
  }
</style>
 